// src/components/shared/Currency.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function Currency(props) {
  const value = Number(props.value);
  const { currency, currentCurrency } = props;

  // Если передали строковый код валюты — возьмём символ из него,
  // иначе — используем сразу переданный объект
  const curr =
    typeof currency === 'string'
      ? { symbol: currency, decimalDigits: 2 }
      : currency || currentCurrency;

  const { symbol, decimalDigits = 2 } = curr;

  return (
    <React.Fragment>
      {symbol}
      {value.toFixed(decimalDigits)}
    </React.Fragment>
  );
}

Currency.propTypes = {
  /** цена (number или строка-число) */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** объект валюты или просто строковый код валюты */
  currency: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** текущая валюта из стора */
  currentCurrency: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentCurrency: state.currency,
});

export default connect(mapStateToProps)(Currency);
